import { message } from 'antd';
import { getAuditLog } from 'api/dashboard';
import { AgentPendingReceiptListData } from 'api/receipt';
import xlsx from 'json-as-xlsx';
import { useEffect } from 'react';

interface DownloadLogsProps {
  record: AgentPendingReceiptListData;
  onDownload: () => void;
}
export default function DownloadLogs({ record, onDownload }: DownloadLogsProps) {
  useEffect(() => {
    const fetchAuditLog = async () => {
      try {
        const res = await getAuditLog(record.PaymentRequestID, false);
        message.success('Download Successfully!');
        // console.log('Response', res);
        let settings = {
          fileName: 'Pending ForReceipt Logs' + record.PaymentRequestID, // Name of the resulting spreadsheet
          extraLength: 3, // A bigger number means that columns will be wider
          writeMode: 'writeFile', // The available parameters are 'WriteFile' and 'write'. This setting is optional. Useful in such cases https://docs.sheetjs.com/docs/solutions/output#example-remote-file
          writeOptions: {}, // Style options from https://github.com/SheetJS/sheetjs#writing-options
          RTL: false, // Display the columns from right-to-left (the default value is false)
        };
        const content = res.data || [];
        const updatedData = content.map((item, index) => ({
          ...item,
          ROWNUM: index + 1,
        }));

        let data = [
          {
            sheet: 'Sheet',
            columns: [
              { label: 'ROWNUM', value: 'ROWNUM' },
              // { label: 'Loan Number', value: 'LANumber' },
              { label: 'PaymentRequestID', value: 'PaymentRequestID' },
              { label: 'Event', value: 'Event' },
              { label: 'Event Date', value: 'EventDateTime' },
              { label: 'Error Description', value: 'ErrorDescription' },

              // { label: 'JsonFormate', value: 'JsonFormate' },
              // { label: 'JsonResult', value: 'JsonResult' },
            ],
            content: updatedData,
          },
        ];
        xlsx(data, settings);
        onDownload();
      } catch (error) {
        console.error('Error fetching audit log:', error);
      }
    };

    fetchAuditLog();
  }, [record]);

  //   console.log('Records', record);
  return <div></div>;
}
